export default "__VITE_ASSET__bkpYmZ12__"